import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { accountLogin } from 'middleware/account/actions';
import Login from './login';

const mapStateToProps = (state) => {
  const {
    isLoggedIn,
    isLoading,
    error,
  } = state.accountReducer;
  return {
    isLoggedIn,
    isLoading,
    error,
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      accountLogin,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);
